import { render, staticRenderFns } from "./aiHealth.vue?vue&type=template&id=b83ec5fc&scoped=true&"
import script from "./aiHealth.vue?vue&type=script&lang=js&"
export * from "./aiHealth.vue?vue&type=script&lang=js&"
import style0 from "./aiHealth.vue?vue&type=style&index=0&id=b83ec5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83ec5fc",
  null
  
)

export default component.exports